import { Guide } from './types';
import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetGuidesRequestOptions = CommonRequestOptions & {
   limit?: number;
   guideids?: number[];
   includePrivate?: boolean;
};

export async function getGuides({
   limit,
   guideids,
   includePrivate,
   ...common
}: GetGuidesRequestOptions = {}): Promise<Guide[]> {
   return makeRequest('get', 'guides', {
      ...common,
      query: {
         limit,
         guideids: guideids?.join(','),
         includePrivate,
      },
   });
}

type GetGuidesErrorCode = 'guides.list.insufficient_permissions';
getGuides.errorMessages = createErrorMessageTypeGuard<GetGuidesErrorCode>();
